import { useState } from "preact/hooks";
import { api } from "./api-client";
import { useToast } from "./use-toast";
import type { ProjectDto } from "@shared/types";

export type DeployState = { kind: "idle" } | { kind: "running" };

// Shared deploy-hook trigger state. The state machine only covers the
// in-flight phase (button loading label); results surface as toasts so they
// never shift the surrounding layout.
export function useDeployHook(project: ProjectDto | null) {
  const [state, setState] = useState<DeployState>({ kind: "idle" });
  const toast = useToast();

  async function trigger() {
    if (!project?.deployHookConfigured || state.kind === "running") return;
    setState({ kind: "running" });
    try {
      const res = await api.triggerDeploy(project.id);
      if (res.ok) {
        toast.success(`デプロイをトリガーしました (${res.status})`);
      } else {
        toast.error(`${res.status}: ${res.body || "失敗"}`);
      }
    } catch (err) {
      toast.error((err as Error).message);
    } finally {
      setState({ kind: "idle" });
    }
  }

  return { state, trigger };
}
